import React from 'react';
import PropTypes from 'prop-types';

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import { Link } from 'react-router';
import SortAlphaIcon from 'material-ui/svg-icons/av/sort-by-alpha';
import IconButton from 'material-ui/IconButton';

const ReportUserProgress = React.createClass({

    getInitialState: function() {
        return ({
            sortCriteria: null,
            sortMapCriteria: null,
        });
    },

    getDefaultProps: function() {
        return {
            display: {
                fixedHeader: true,
                fixedFooter: true,
                stripedRows: false,
                showRowHover: false,
                showCheckboxes: false,
                selectable: false,
                multiSelectable: false,
                enableSelectAll: false,
                deselectOnClickaway: false,
            },
            data: []
        };
    },

    render: function() {
        let data = this.props.data.map((row) => {
            row.name = `${row.courseName} (${row.courseCode})`;
            row.enrolments = Number(row.enrolments);
            row.completed = Number(row.completed);
            row.waiting = Number(row.waiting);
            return row;
        });

        if (this.state.sortCriteria) {
            const mapped = data.map(this.state.sortMapCriteria);
            mapped.sort(this.state.sortCriteria);
            data = mapped.map((el) => data[el.index]);
        }

        let tableHeaderProps = {
            enableSelectAll:   this.props.display.enableSelectAll,
            displaySelectAll:  this.props.display.enableSelectAll,
            adjustForCheckbox: this.props.display.enableSelectAll
        };
        let tableProps = {
            height:             this.props.display.height,
            fixedHeader:        this.props.display.fixedHeader,
            fixedFooter:        this.props.display.fixedFooter,
            displayRowCheckbox: !!this.props.showCheckboxes,
            selectable:         this.props.display.selectable,
            multiSelectable:    this.props.display.multiSelectable,
        };
        let tableBodyProps = {
            deselectOnClickaway: this.props.display.deselectOnClickaway,
            displayRowCheckbox:  this.props.display.showCheckboxes,
            showRowHover:        this.props.display.showRowHover,
            stripedRows:         this.props.display.stripedRows,
        };
        if (!!this.props.onRowSelect) {
            tableProps.onRowSelection = this.props.onRowSelect;
        }
        return (
            <Table {...tableProps} >
                <TableHeader {...tableHeaderProps} >
                    <TableRow>
                        <TableHeaderColumn>
                            Course <IconButton onTouchTap={() => this.sort('course')}><SortAlphaIcon/></IconButton>
                        </TableHeaderColumn>
                        <TableHeaderColumn className="tbl-td-number">
                            Waiting <IconButton onTouchTap={() => this.sort('waiting')}><SortAlphaIcon/></IconButton>
                        </TableHeaderColumn>
                        <TableHeaderColumn className="tbl-td-number">
                            Enrolments <IconButton onTouchTap={() => this.sort('enrolments')}><SortAlphaIcon/></IconButton>
                        </TableHeaderColumn>
                        <TableHeaderColumn className="tbl-td-number">
                            Completed <IconButton onTouchTap={() => this.sort('completed')}><SortAlphaIcon/></IconButton>
                        </TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody {...tableBodyProps} >
                    {data.map((row, index) => (
                        <TableRow key={index} selected={row.selected}>
                            <TableRowColumn>
                                { this.props.withLinks ? <Link to={`/dashboard/course/${row.id}`}>{row.name}</Link> : row.name }
                            </TableRowColumn>
                            <TableRowColumn className="tbl-td-number">{row.waiting || 0}</TableRowColumn>
                            <TableRowColumn className="tbl-td-number">{row.enrolments}</TableRowColumn>
                            <TableRowColumn className="tbl-td-number">{row.completed || 0}</TableRowColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    },

    sort: function(sort) {
        let sortCriteria, sortMapCriteria;
        switch (sort) {
            case 'course':
                sortCriteria = (a, b) => a.value.localeCompare(b.value);
                sortMapCriteria = (el, i) => ({ index: i, value: el.name });
                break;
            case 'waiting':
                sortCriteria = (a, b) => a.value - b.value;
                sortMapCriteria = (el, i) => ({ index: i, value: el.waiting });
                break;
            case 'enrolments':
                sortCriteria = (a, b) => a.value - b.value;
                sortMapCriteria = (el, i) => ({ index: i, value: el.enrolments });
                break;
            case 'completed':
                sortCriteria = (a, b) => a.value - b.value;
                sortMapCriteria = (el, i) => ({ index: i, value: Number(el.completed) });
                break;
            default:
                sortCriteria = (a, b) => (a.value - b.value);
                sortMapCriteria = (el, i) => ({ index: i, value: el[this.state.sort] });
        }
        this.setState({ sort, sortCriteria, sortMapCriteria });
    }
});

ReportUserProgress.propTypes = {
    display: PropTypes.object,
    onRowSelect: PropTypes.func,
    data: PropTypes.arrayOf(PropTypes.object),
    withLinks: PropTypes.bool
};

ReportUserProgress.defaultProps = {
    withLinks: true
};

export default ReportUserProgress;
